export default "__VITE_ASSET__ird7dzWB__"